import { ICategory, IContainerType, ILot, IProduct } from "@/models";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IdbStorage } from ".";

export interface ProductState {
  products: IProduct[] | undefined;
  setProducts: (products: IProduct[] | undefined) => void;
  currentProduct: IProduct | undefined;
  setCurrentProduct: (currentProduct: IProduct | undefined) => void;
  filteredProducts: IProduct[] | undefined;
  setFilteredProducts: (filteredProducts: IProduct[] | undefined) => void;
  categories: ICategory[] | undefined;
  setCategories: (categories: ICategory[] | undefined) => void;
  lots: ILot[] | undefined;
  setLots: (lots: ILot[] | undefined) => void;
  existProductLots: boolean;
  setExistProductLots: (existProductLots: boolean) => void;
  containerTypeGlobal: IContainerType;
  setContainerTypeGlobal: (containerType: IContainerType) => void;
  quantityavailable: number;
  setQuantityavailable: (quantityavailable: number) => void;
  resetStore: () => void;
}

export const useProductStore = create<ProductState>()(
  devtools(
    persist(
      (set) => ({
        products: undefined,
        setProducts: (products: IProduct[] | undefined) => set({ products }),
        currentProduct: undefined,
        setCurrentProduct: (currentProduct: IProduct | undefined) => {
          set({ currentProduct });
        },
        filteredProducts: undefined,
        setFilteredProducts: (filteredProducts: IProduct[] | undefined) =>
          set({ filteredProducts }),
        categories: undefined,
        setCategories: (categories: ICategory[] | undefined) =>
          set({ categories }),
        lots: undefined,
        setLots: (lots: ILot[] | undefined) => set({ lots }),
        existProductLots: true,
        setExistProductLots: (existProductLots: boolean) =>
          set({ existProductLots }),
        containerTypeGlobal: {
          alias: "",
          id: 0,
          name: "",
          price: 0,
          quantity: 0,
        },
        setContainerTypeGlobal: (containerTypeGlobal: IContainerType) =>
          set({ containerTypeGlobal }),
        quantityavailable: 0,
        setQuantityavailable: (quantityavailable: number) =>
          set({ quantityavailable }),
        resetStore: () =>
          set({
            products: undefined,
            currentProduct: undefined,
            filteredProducts: undefined,
            categories: undefined,
            lots: undefined,
            existProductLots: true,
            containerTypeGlobal: {
              alias: "",
              id: 0,
              name: "",
              price: 0,
              quantity: 0,
            },
            quantityavailable: 0,
          }),
      }),
      {
        name: "product-store-v2",
        partialize: (state) => ({
          products: state.products,
          currentProduct: state.currentProduct,
          filteredProducts: state.filteredProducts,
          categories: state.categories,
        }),
        storage: createJSONStorage(() => IdbStorage),
      }
    )
  )
);
